import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/assignUnit';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { keys, unit } = action?.payload || {};
  try {
    yield call(
      axios.post,
      `${config.API_URL}/signal/units/assign`,
      { keys, unit },
      { headers: getLocalUser() },
    );
    // Echo the request inputs so the list can update the affected rows
    // locally (the BE enriches the next GET /signal with the same unit).
    yield put(fetchSuccess({ keys, unit, at: Date.now() }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
